export enum LinkTarget {
    Self = '_self',
    Blank = '_blank',
}
